import { Model, attr, fk } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'AlertSetting';

  static fields = {
    id: attr(),
    name: attr(),
    deviceId: fk({
      to: 'Device',
      as: 'device',
      relatedName: 'alertSettings',
    }),
    itemId: fk({
      to: 'Item',
      as: 'item',
      relatedName: 'alertSettings',
    }),
  };

  static reducer({ type, payload }, AlertSetting) {
    switch (type) {
      case ActionTypes.ALERTS_SETTING_FETCH_SUCCEEDED:
        payload.alertsSetting.forEach((alertSetting) => {
          AlertSetting.upsert(alertSetting);
        });

        break;
      case ActionTypes.ALERT_SETTING_UPDATE: {
        const alertSetting = AlertSetting.withId(payload.id);
        alertSetting.update(payload.data);
        break;
      }
      case ActionTypes.ALERT_SETTING_DELETE:
        AlertSetting.withId(payload.id).deleteWithRelated();

        break;
      case ActionTypes.ALERT_SETTING_CREATE_SUCCEEDED:
      case ActionTypes.ALERT_SETTING_CREATE_RECEIVED:
        AlertSetting.upsert(payload.item);

        break;
      case ActionTypes.ALERT_SETTING_UPDATE_RECEIVED:
        AlertSetting.withId(payload.alertSetting.id).update(payload.alertSetting);

        break;
      case ActionTypes.ALERT_SETTING_DELETE_RECEIVED:
        AlertSetting.withId(payload.alertSetting.id).deleteWithRelated();

        break;
      default:
    }
  }

  static getOrderedQuerySet() {
    return this.orderBy('id');
  }

  getOrderedAlertsQuerySet() {
    return this.alerts.orderBy('id');
  }

  deleteWithRelated() {
    // this.models.toModelArray().forEach((modelModel) => {
    //   modelModel.deleteWithRelated();
    // });

    this.delete();
  }
}
